module.exports = __webpack_public_path__ + "img/attack_goldencoin.5078c12f.png";